import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminDashboardComponent } from './components/dashboard/dashboard.component';

const routes: Routes = [
  {
    path: 'dashboard',
    component: AdminDashboardComponent,
    data: { title: 'Dashboard' },
  },
  {
    path: 'super',
    loadChildren: () =>
      import('src/app/modules/admin/modules/superadmin/superadmin.module').then(
        (m) => m.SuperadminModule
      ),
  },
  {
    path: 'facilidad',
    loadChildren: () =>
      import('src/app/modules/admin/modules/visor/visor.module').then(
        (m) => m.VisorModule
      ),
  },
  {
    path: 'facilidad',
    loadChildren: () =>
      import(
        'src/app/modules/admin/modules/diagnosticador-visor/Diagnosticadorvisor.module'
      ).then((m) => m.DiagnosticadorVisorModule),
  },
  {
    path: 'facilidad',
    loadChildren: () =>
      import(
        'src/app/modules/admin/modules/uflow-web/uflow-web.module'
      ).then((m) => m.UflowWebModule),
  },
  {
    path: 'cuotas',
    loadChildren: () =>
      import('src/app/modules/admin/modules/cuotas/cuotas.module').then(
        (m) => m.CuotasModule
      ),
  },
  {
    path: 'cartera',
    loadChildren: () =>
      import('src/app/modules/admin/modules/cartera/cartera.module').then(
        (m) => m.CarteraModule
      ),
  },
  {
    path: 'colocacionweb',
    loadChildren: () =>
      import(
        'src/app/modules/admin/modules/colocacionweb/colocacionweb.module'
      ).then((m) => m.ColocacionwebModule),
  },
  {
    path: 'movilidad',
    loadChildren: () =>
      import('src/app/modules/admin/modules/movilidad/movilidad.module').then(
        (m) => m.MovilidadModule
      ),
  },
  {
    path: 'comve',
    loadChildren: () =>
      import('src/app/modules/admin/modules/comve/comve.module').then(
        (m) => m.ComveModule
      ),
  },
  {
    path: 'comcre',
    loadChildren: () =>
      import('src/app/modules/admin/modules/comcre/comcre.module').then(
        (m) => m.ComcreModule
      ),
  },
  {
    path: 'surtismart',
    loadChildren: () =>
      import('src/app/modules/admin/modules/surtismart/surtismart.module').then(
        (m) => m.SurtismartModule
      ),
  },
  {
    path: 'retail',
    loadChildren: () =>
      import('src/app/modules/admin/modules/retail/retail.module').then(
        (m) => m.RetailModule
      ),
  },
  {
    path: 'herramienta',
    loadChildren: () =>
      import(
        'src/app/modules/admin/modules/herramienta/herramienta.module'
      ).then((m) => m.HerramientaModule),
  },
  {
    path: 'credito',
    loadChildren: () =>
      import('src/app/modules/admin/modules/credito/credito.module').then(
        (m) => m.CreditoModule
      ),
  },
  {
    path: 'riesgo',
    loadChildren: () =>
      import('src/app/modules/admin/modules/riesgo/riesgo.module').then(
        (m) => m.RiesgoModule
      ),
  },
  {
    path: 'soporte',
    loadChildren: () =>
      import('src/app/modules/admin/modules/soporte/soporte.module').then(
        (m) => m.SoporteModule
      ),
  },
  {
    path: 'riesgo',
    loadChildren: () =>
      import('src/app/modules/admin/modules/riesgo/riesgo.module').then(
        (m) => m.RiesgoModule
      ),
  },
  {
    path: 'parametrizacion',
    loadChildren: () =>
      import(
        'src/app/modules/admin/modules/parametrizacion/parametrizacion.module'
      ).then((m) => m.ParametrizacionModule),
  },
  {
    path: 'logistica',
    loadChildren: () =>
      import('src/app/modules/admin/modules/logistica/logistica.module').then(
        (m) => m.LogisticaModule
      ),
  },
  {
    path: 'procesos',
    loadChildren: () =>
      import('src/app/modules/admin/modules/procesos/procesos.module').then(
        (m) => m.ProcesosModule
      ),
  },
  {
    path: 'asignar-proveedor',
    loadChildren: () =>
      import('src/app/modules/admin/modules/asignar-proveedor/asignar-proveedor.module').then(
        (m) => m.AsignarProveedorModule
      ),
  },
  {
    path: 'cartons',
    loadChildren: () =>
      import(
        'src/app/modules/admin/modules/cartones-pop/cartones-pop.module'
      ).then((m) => m.CartonesPopModule),
  },
  {
    path: 'indicadores',
    loadChildren: () =>
      import(
        'src/app/modules/admin/modules/indicadores/indicadores.module'
      ).then((m) => m.IndicadoresModule),
  },
  {
    path: 'venta-muestras',
    loadChildren: () =>
      import(
        'src/app/modules/admin/modules/venta-muestras/venta-muestras.module'
      ).then((m) => m.VentaMuestrasModule),
  },
  {
    path: 'venta-ya',
    loadChildren: () =>
      import('src/app/modules/admin/modules/ventaya/ventaya.module').then(
        (m) => m.VentayaModule
      ),
  },
  {
    path: 'salesforce',
    loadChildren: () =>
      import('src/app/modules/admin/modules/salesforce/salesforce.module').then(
        (m) => m.SalesforceModule
      ),
  },
  {
    path: 'garantia-extendida',
    loadChildren: () =>
      import(
        'src/app/modules/admin/modules/garantia-extendida/garantia-extendida.module'
      ).then((m) => m.GarantiaExtendidaModule),
  },
  {
    path: 'events',
    loadChildren: () =>
      import(
        'src/app/modules/admin/modules/events/events.module'
      ).then((m) => m.EventsModule),
  },
  {
    path: 'billing-operations',
    loadChildren: () =>
      import(
        'src/app/modules/admin/modules/billing-operations/billing-operations.module'
      ).then((m) => m.BillingOperationsModule),
  },
  {
    path: 'comisionesdevendedores',
    loadChildren: () => import('./modules/comisionesdevendedores/comisionesdevendedores.module'
    ).then(m => m.ComisionesdevendedoresModule)

  },
  {
    path: 'administradordemonitoreos',
    loadChildren: () => import('./modules/administradordemonitoreos/administradordemonitoreos.module'
    ).then(m => m.AdministradordemonitoreoModule)

  },
  {
    path: 'sistema-aid',
    loadChildren: () =>
      import('./modules/sistema-aid/sistema-aid.module').then(m => m.SistemaAidModule)
  },
  {
    path: 'presupuesto',
    loadChildren: () =>
      import('src/app/modules/admin/modules/presupuesto/presupuesto.module').then(
        (m) => m.PresupuestoModule
      ),
  },
  {
    path: 'buscador-logs',
    loadChildren: () =>
      import('src/app/modules/admin/modules/appventas/appventas.module').then(
        (m) => m.AppventasModule
      ),
  },
  {
    path: 'pagaygana-new',
    loadChildren: () =>
      import('src/app/modules/admin/modules/pagaygana-new/pagaygana-new.module').then(
        (m) => m.PagayganaNewModule
      )
  },
  {
    path: 'guias-exhibicion',
    loadChildren: () =>
      import('src/app/modules/admin/modules/guias-exhibicion/guias-exhibicion.module').then(
        (m) => m.GuiasExhibicionModule
      )
  },
  {
    path: 'curva-valor-producto',
    loadChildren: () =>
      import('src/app/modules/admin/modules/curva-valor-producto/curva-valor-producto.module').then(
        (m) => m.CurvaValorProductoModule
      ),
  },
  {
    path: 'politicas',
    loadChildren: () =>
      import('src/app/modules/admin/modules/politicas/politicas.module').then(
        (m) => m.PoliticasModule
      ),
  },
  {
    path: 'auditoria',
    loadChildren: () =>
      import('src/app/modules/admin/modules/auditoria/auditoria.module').then(
        (m) => m.AuditoriaModule
      ),
  },
  {
    path: 'parametrizacion-informacion',
    loadChildren: () =>
      import(
        'src/app/modules/admin/modules/parametrizacion-informacion/parametrizacion-informacion.module'
      ).then((m) => m.ParametrizacionInformacionModule),
  },
  { path: '', redirectTo: 'dashboard', pathMatch: 'prefix' },
  { path: '**', redirectTo: 'dashboard', pathMatch: 'prefix' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminRoutingModule { }
